<section class="section white-100" *ngIf="featuresData">
  <div class="section-container">
    <div class="benefit-your-clients benefit-partner">
      <div class="benefit-your-clients-content white">
        <div *ngFor="let card of featuresData?.component1">
          <img
            src="{{ card?.fields?.imageicon?.fields?.file?.url }}"
            alt="{{ card?.fields?.imageicon?.fields?.title }}"
          />
          <div class="security-compliance-heading">
            {{ card?.fields?.title }}
          </div>
          <div
            class="security-compliance-description"
            [innerHtml]="card?.fields?.description | toHtml"
          ></div>
        </div>
      </div>
      <img
        loading="lazy"
        class="feature-full-image"
        src="{{ featuresData?.image?.[0]?.fields?.file?.url }}"
        alt="{{ featuresData?.image?.[0]?.fields?.title }}"
      />
    </div>
  </div>
</section>
